/**
 * Build a URLSearchParams object from a plain object,
 * stripping null, undefined, and empty string values.
 *
 * @param {Object} params - Key-value pairs for query parameters
 * @returns {URLSearchParams}
 */
export function buildParams(params) {
    return new URLSearchParams(Object.entries(params).filter(([, v]) => v != null && v !== ''));
}
